import { useSelector } from 'react-redux';
import { ShoppingState } from '@/reducers/shopping';

export default function useShopping() {
  const shopping = useSelector((state: { shopping: ShoppingState }) => state.shopping.shopping);
  const error = useSelector((state: { shopping: ShoppingState }) => state.shopping.error);

  return [shopping, error] as const;
}
